import './_related-product-options.scss';
import component from './related-product-options';

export default component;
